import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {environment} from "@environment";
import {enableProdMode} from "@angular/core";
import {overrideDateToJSONMethodToSerializeDateToLocalDateTime, overrideJSONParseToDeserializeDate} from './app/utility/common';

overrideDateToJSONMethodToSerializeDateToLocalDateTime();
overrideJSONParseToDeserializeDate();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
